<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="sheet">
                    <icon name="database"></icon> รายการสต็อคชีททั้งหมด </b-nav-item>&nbsp
                <b-nav-item router-link to="sheet-import"
                            v-if="canInventorySheetsImport || canInventorySheetsImportView">
                    <icon name="download"></icon>
                    รายการนำเข้าสต็อคชีท </b-nav-item>&nbsp
                <b-nav-item router-link to="sheet-export"
                            v-if="canInventorySheetsExport || canInventorySheetsExportView">
                    <icon name="upload"></icon> รายการเบิกสต็อคชีท
                </b-nav-item>
                &nbsp;
                <b-nav-item router-link to="sheet-type"
                            v-if="canInventorySheetsExport || canInventorySheetsExportView">
                    <icon name="scroll"></icon> ประเภทชีท
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>
<script>
    import {
        canInventorySheetsImport,
        canInventorySheetsImportView,
        canInventorySheetsExport,
        canInventorySheetsExportView
    } from "../../util/Permissions";
export default {
    name: "sheet-layout",
    computed:{
        canInventorySheetsImport,
        canInventorySheetsImportView,
        canInventorySheetsExport,
        canInventorySheetsExportView
    }
};
</script>
